import {
  getAllBranches,
  addBranch,
  updateBranch,
  deleteBranch,
  getBranchesCountryOptions,
  getBranchesByCompanyId,
  updateBranchAdmin,
} from '../utils/requests/companyAPI'

export const BRANCHES_LOAD_BRANCHES = 'BRANCHES_LOAD_BRANCHES'
export const BRANCHES_LOAD_BRANCHES_PENDING = 'BRANCHES_LOAD_BRANCHES_PENDING'
export const BRANCHES_LOAD_BRANCHES_FULFILLED = 'BRANCHES_LOAD_BRANCHES_FULFILLED'
export const BRANCHES_LOAD_BRANCHES_REJECTED = 'BRANCHES_LOAD_BRANCHES_REJECTED'

export const BRANCHES_LOAD_NEW_BRANCHES = 'BRANCHES_LOAD_NEW_BRANCHES'
export const BRANCHES_LOAD_NEW_BRANCHES_PENDING = 'BRANCHES_LOAD_NEW_BRANCHES_PENDING'
export const BRANCHES_LOAD_NEW_BRANCHES_FULFILLED = 'BRANCHES_LOAD_NEW_BRANCHES_FULFILLED'
export const BRANCHES_LOAD_NEW_BRANCHES_REJECTED = 'BRANCHES_LOAD_NEW_BRANCHES_REJECTED'

export const BRANCHES_LOAD_BRANCHES_BY_COMPANY_ID = 'BRANCHES_LOAD_BRANCHES_BY_COMPANY_ID'
export const BRANCHES_LOAD_BRANCHES_BY_COMPANY_ID_PENDING = 'BRANCHES_LOAD_BRANCHES_BY_COMPANY_ID_PENDING'
export const BRANCHES_LOAD_BRANCHES_BY_COMPANY_ID_FULFILLED = 'BRANCHES_LOAD_BRANCHES_BY_COMPANY_ID_FULFILLED'
export const BRANCHES_LOAD_BRANCHES_BY_COMPANY_ID_REJECTED = 'BRANCHES_LOAD_BRANCHES_BY_COMPANY_ID_REJECTED'

export const BRANCHES_POST_BRANCH = 'BRANCHES_POST_BRANCH'
export const BRANCHES_POST_BRANCH_PENDING = 'BRANCHES_POST_BRANCH_PENDING'
export const BRANCHES_POST_BRANCH_FULFILLED = 'BRANCHES_POST_BRANCH_FULFILLED'
export const BRANCHES_POST_BRANCH_REJECTED = 'BRANCHES_POST_BRANCH_REJECTED'

export const BRANCHES_PUT_BRANCH = 'BRANCHES_PUT_BRANCH'
export const BRANCHES_PUT_BRANCH_PENDING = 'BRANCHES_PUT_BRANCH_PENDING'
export const BRANCHES_PUT_BRANCH_FULFILLED = 'BRANCHES_PUT_BRANCH_FULFILLED'
export const BRANCHES_PUT_BRANCH_REJECTED = 'BRANCHES_PUT_BRANCH_REJECTED'

export const BRANCHES_PUT_BRANCH_ADMIN = 'BRANCHES_PUT_BRANCH_ADMIN'
export const BRANCHES_PUT_BRANCH_ADMIN_PENDING = 'BRANCHES_PUT_BRANCH_ADMIN_PENDING'
export const BRANCHES_PUT_BRANCH_ADMIN_FULFILLED = 'BRANCHES_PUT_BRANCH_ADMIN_FULFILLED'
export const BRANCHES_PUT_BRANCH_ADMIN_REJECTED = 'BRANCHES_PUT_BRANCH_ADMIN_REJECTED'

export const BRANCHES_DELETE_BRANCH = 'BRANCHES_DELETE_BRANCH'
export const BRANCHES_DELETE_BRANCH_PENDING = 'BRANCHES_DELETE_BRANCH_PENDING'
export const BRANCHES_DELETE_BRANCH_FULFILLED = 'BRANCHES_DELETE_BRANCH_FULFILLED'
export const BRANCHES_DELETE_BRANCH_REJECTED = 'BRANCHES_DELETE_BRANCH_REJECTED'

export const BRANCHES_LOAD_BRANCHES_COUNTRY_OPTIONS = 'BRANCHES_LOAD_BRANCHES_COUNTRY_OPTIONS'
export const BRANCHES_LOAD_BRANCHES_COUNTRY_OPTIONS_PENDING = 'BRANCHES_LOAD_BRANCHES_COUNTRY_OPTIONS_PENDING'
export const BRANCHES_LOAD_BRANCHES_COUNTRY_OPTIONS_FULFILLED = 'BRANCHES_LOAD_BRANCHES_COUNTRY_OPTIONS_FULFILLED'
export const BRANCHES_LOAD_BRANCHES_COUNTRY_OPTIONS_REJECTED = 'BRANCHES_LOAD_BRANCHES_COUNTRY_OPTIONS_REJECTED'

export const BRANCHES_CLEAR_BRANCHES_MESSAGES = 'BRANCHES_CLEAR_BRANCHES_MESSAGES'

export function loadBranches(queryParams, refetch = false) {
  return {
    type: refetch ? BRANCHES_LOAD_NEW_BRANCHES : BRANCHES_LOAD_BRANCHES,
    payload: getAllBranches(queryParams),
  }
}

export function loadBranchesByCompanyId(companyId) {
  return {
    type: BRANCHES_LOAD_BRANCHES_BY_COMPANY_ID,
    payload: getBranchesByCompanyId(companyId),
  }
}

export function createBranch(companyId, bodyParams) {
  return {
    type: BRANCHES_POST_BRANCH,
    payload: addBranch(companyId, bodyParams),
  }
}

export function putBranch(companyId, branchId, bodyParams) {
  return {
    type: BRANCHES_PUT_BRANCH,
    payload: updateBranch(companyId, branchId, bodyParams),
  }
}

export function changeBranchAdmin(companyId, branchId, bodyParams) {
  return {
    type: BRANCHES_PUT_BRANCH_ADMIN,
    payload: updateBranchAdmin(companyId, branchId, bodyParams),
  }
}

export function removeBranch(companyId, branchId) {
  return {
    type: BRANCHES_DELETE_BRANCH,
    payload: deleteBranch(companyId, branchId),
    meta: { branchId },
  }
}

export function loadBranchesCountryOptions() {
  return {
    type: BRANCHES_LOAD_BRANCHES_COUNTRY_OPTIONS,
    payload: getBranchesCountryOptions(),
  }
}

export function clearBranchesMessages() {
  return {
    type: BRANCHES_CLEAR_BRANCHES_MESSAGES,
  }
}

export function clearUserBranches() {
  return {
    type: 'CLEAR_USER_BRANCHES',
  }
}
